export default __webpack_public_path__ + "static/media/5nance-partner.56ae103f.svg";